import { createSelector } from '@reduxjs/toolkit';
import camelcaseKeys from 'camelcase-keys';

const getProductTypeEntitiesById = (state) => state?.types?.productTypes || {};

const getPassengerTypes = (state) => state.types?.passengerTypes || [];

const getProductTypes = createSelector(
  [getProductTypeEntitiesById],
  (productTypes) =>
    Object.values(productTypes).map((productType) => camelcaseKeys(productType))
);

const getQTVehicleTypes = (state) => state?.types?.vehicleTypes || [];

// Return the type id of the first vehicle type with a segment code
const getQtVehicleTypeId = createSelector(
  [getQTVehicleTypes],
  (qtVehicleTypes) => {
    const carType = qtVehicleTypes.find((type) => !!type.segment_code);

    return {
      vehicleSegmentCode: carType?.segment_code,
      qtVehicleTypeIdOfSavedCar: carType?.id,
    };
  }
);

export {
  getProductTypeEntitiesById,
  getPassengerTypes,
  getProductTypes,
  getQTVehicleTypes,
  getQtVehicleTypeId,
};
